// Module
var code = "<div class=\"padding-vert-half bank-info-search-result\"> <b>{{ match.label.contact.name}}</b><br/> <small>{{ match.label.contact.city }}</small> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/components/bankInfo/partials/search.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;